import { render, staticRenderFns } from "./ChatModal.vue?vue&type=template&id=4e20eccc"
import script from "./ChatModal.vue?vue&type=script&lang=js"
export * from "./ChatModal.vue?vue&type=script&lang=js"
import style0 from "./ChatModal.vue?vue&type=style&index=0&id=4e20eccc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports